import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import LinkBuilder from '../../../../../../helpers/link-builder';

const FeedPostContentFirmLink = props => {
  const {
    isActive,
    alias,
    firm,
    school,
    cls = 'feed-post-content__span',
    clsSpan,
  } = props;

  return firm ? (
    isActive ? (
      <NavLink className={cls} to={LinkBuilder.getFirmLink(alias)}>
        {firm}
      </NavLink>
    ) : (
      <span className={cls}>{firm}</span>
    )
  ) : school ? (
    <span className={clsSpan || cls}>{school}</span>
  ) : null;
};

FeedPostContentFirmLink.propTypes = {
  isActive: PropTypes.bool,
  firm: PropTypes.string,
  school: PropTypes.string,
  alias: PropTypes.string,
  cls: PropTypes.string,
  clsSpan: PropTypes.string,
};

export default FeedPostContentFirmLink;
